/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
//
import Turbolinks from 'turbolinks'
import 'jquery'
import 'jquery-ujs'
import 'react'
import 'react-dom'
import 'domurl'
import ReactRailsUJS from 'react_ujs'

import '../helpers'
import '../dbcom'
import '../plugins'

const componentRequireContext = require.context('components', true)

ReactRailsUJS.useContext(componentRequireContext)

window.componentRequireContext = componentRequireContext

/**
 * Looks like Turbolinks hates custom error pages? https://github.com/turbolinks/turbolinks/issues/179
 *
 * So this is basically a copy pasta of someone's solution from that thread. I think that it's OK
 * for us to do this (even though it seems gross) because from what I can tell the server response
 * is still the error code, so (I think) crawlers will still evaluate that and behave properly.
 * This is just overriding Turbolinks to load the error message as if it were a 200. Seems silly
 * but shrug emoji.
 *
 * @returns {idk} Whatever `this.endRequest` returns
 */
Turbolinks.HttpRequest.prototype.requestLoaded = function requestLoaded() {
  return this.endRequest(() => {
    const code = this.xhr.status

    if (
      (code >= 200 && code < 300) ||
      code === 403 ||
      code === 404 ||
      code === 500
    ) {
      this.delegate.requestCompletedWithResponse(
        this.xhr.responseText,
        this.xhr.getResponseHeader('Turbolinks-Location'),
      )
    } else {
      this.failed = true
      this.delegate.requestFailedWithStatusCode(code, this.xhr.responseText)
    }
  })
}

/**
 * This is something special we have to add in order for the `react-rails` gem to properly load
 * React components when used with Turbolinks.
 *
 * @see https://github.com/reactjs/react-rails#event-handling
 */
// Order is particular. First start Turbolinks:
Turbolinks.start()
// Add Turbolinks to the global namespace:
window.Turbolinks = Turbolinks
// Remove previous event handlers and add new ones:
ReactRailsUJS.detectEvents()
